<template>
  <div :class="['report-recibidos-container', $vuetify.theme.dark ? 'dark-mode' : '']">
    <!-- CABECERA AUDIT PROFESIONAL 🏛️ -->
    <v-toolbar flat height="64" class="audit-header px-4">
      <v-toolbar-title :class="['audit-title d-flex align-center', $vuetify.theme.dark ? 'white--text' : 'grey--text text--darken-4']">
        <v-icon large color="blue-grey darken-3" class="mr-3">mdi-clipboard-list-outline</v-icon>
        DOCUMENTOS RECIBIDOS
      </v-toolbar-title>
      <v-spacer />
      <v-btn icon color="grey darken-2" @click="$router.push('/home')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- PANEL DE FILTROS COMPACTO 🔍 -->
    <v-card flat class="filter-dense-panel pa-3 mx-2 mt-2">
      <v-row dense align="center">
        <!-- Selector de Periodo -->
        <v-col cols="12" md="2">
          <v-select
            v-model="criterioReporte" 
            :items="['Hoy', 'Ayer', 'Este Mes', 'Personalizado']"
            label="Criterio" 
            outlined dense hide-details
            prepend-inner-icon="mdi-calendar-range"
            class="audit-input"
          ></v-select>
        </v-col>
        
        <v-col cols="12" md="3">
          <v-dialog ref="dialog" v-model="dateModal" :return-value.sync="dates" persistent width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dates" label="Periodo (Desde - Hasta)" 
                prepend-inner-icon="mdi-calendar-month" readonly 
                outlined dense hide-details v-bind="attrs" v-on="on"
                class="audit-input"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dates" range color="blue-grey darken-3">
              <v-spacer />
              <v-btn text color="grey darken-1" @click="dateModal = false">Cancel</v-btn>
              <v-btn text color="blue-grey darken-3" @click="$refs.dialog.save(dates)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>

        <!-- Filtros Multiples -->
        <v-col cols="12" md="2">
          <v-select
            v-model="selectedMonedas" :items="monedas" item-text="md_nombre" item-value="md_codigo"
            label="Moneda" multiple outlined dense hide-details
            class="audit-input"
          ></v-select>
        </v-col>

        <v-col cols="12" md="2">
          <v-select
            v-model="selectedTiposDocumentos" :items="tiposDocumentos" item-text="documento" item-value="tipoDocumento"
            label="Tipo de documento" multiple outlined dense hide-details
            class="audit-input"
          ></v-select>
        </v-col>

        <!-- Botón Filtrar Principal -->
        <v-col cols="12" md="1">
          <v-btn block color="blue-grey darken-3" dark @click="getReport" class="audit-btn elevation-0">
             <v-icon left size="18">mdi-filter</v-icon> Filtrar
          </v-btn>
        </v-col>
      </v-row>

      <!-- Fila 2 de Filtros (Búsqueda por Emisor) -->
      <v-row dense class="mt-2" align="center">
        <v-col cols="12" md="3">
          <v-text-field
            v-model="reporteRecibidos.nombreEmisor"
            label="Buscar por Emisor (Nombre)" 
            outlined dense hide-details rounded
            prepend-inner-icon="mdi-account-search"
            class="audit-input"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field v-model="reporteRecibidos.cedulaEmisor" label="Cédula Emisor" outlined dense hide-details rounded class="audit-input"></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field v-model="reporteRecibidos.clave" label="Clave Hacienda" outlined dense hide-details rounded class="audit-input"></v-text-field>
        </v-col>

        <v-spacer />
        
        <div class="d-flex align-center pb-1">
          <v-btn outlined height="38" color="blue-grey darken-2" @click="getReport" class="audit-btn mr-2 px-4 shadow-sm" style="font-size: 0.75rem;">
            <v-icon left size="18">mdi-refresh</v-icon>
            Refrescar Datos
          </v-btn>
          
          <v-divider vertical class="mx-2" height="24" />

          <vue-excel-xlsx v-if="items2.length > 0" :data="items2" :columns="columns" :filename="'Auditoria_DocumentosRecibidos'" :sheetname="'Compras'">
            <v-btn depressed height="38" color="success darken-1" dark class="audit-btn ml-2 px-4 shadow-sm" style="font-size: 0.75rem;">
              <v-icon left size="18">mdi-microsoft-excel</v-icon> Exportar Excel
            </v-btn>
          </vue-excel-xlsx>
        </div>
      </v-row>
    </v-card>

    <!-- CUERPO DE TABLA AUDIT ESTILO ACERO 📽️ -->
    <div class="audit-table-wrapper pa-2">
      <v-data-table
        :headers="headers2"
        :items="filteredItems"
        class="audit-table audit-zebra elevation-0"
        disable-pagination
        hide-default-footer
        fixed-header
        height="calc(100vh - 460px)"
        :loading="loading"
      >
        <template v-slot:item.clienteNombre="{ item }">
          <div class="d-flex flex-column">
             <span :class="['font-weight-bold text-truncate', $vuetify.theme.dark ? 'white--text' : 'grey--text text--darken-4']" style="max-width: 320px;">{{ item.clienteNombre }}</span>
             <span class="caption" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">{{ item.cedulaReceptor }}</span>
          </div>
        </template>

        <template v-slot:item.estadoHaciendaEmisor="{ item }">
          <v-chip dark small label :color="item.estadoHaciendaEmisor === 'ACEPTADO' ? 'success' : 'error'" class="font-weight-black">
            {{ item.estadoHaciendaEmisor }}
          </v-chip>
        </template>

        <template v-slot:item.totalVentaStr="{ item }">
          <span class="font-weight-bold" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-3' : 'grey--text text--darken-3'">₡ {{ formatPrice(item.totalVenta) }}</span>
        </template>

        <template v-slot:item.totalImpuestoStr="{ item }">
          <span class="caption" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-2' : 'grey--text'">₡ {{ formatPrice(item.totalImpuesto) }}</span>
        </template>
        
        <template v-slot:item.estadoAceptacion="{ item }">
          <v-chip small dense label class="font-weight-black" :color="item.estadoAceptacion === 'ACEPTADO' ? 'success' : 'orange'" style="width: 100%;" dark>
            {{ item.estadoAceptacion }}
          </v-chip>
        </template>

        <!-- COLUMNA DE CLASIFICACIÓN DEFINITIVA (M o S) 📦⚖️ -->
        <template v-slot:item.clasificacion="{ item }">
          <v-chip
            small
            dense
            label
            class="font-weight-black"
            style="width: 100%; cursor: pointer;"
            :color="getInvColor(item)"
            dark
            @click="toggleEstadoInventario(item)"
          >
            <v-icon left size="14">mdi-layers-triple-outline</v-icon>
            {{ getInvText(item) }}
          </v-chip>
        </template>

        <template v-slot:item.totalComprobanteStr="{ item }">
          <span :class="['font-weight-black', $vuetify.theme.dark ? 'teal--text text--lighten-2' : 'blue-grey--text text--darken-4']">₡ {{ formatPrice(item.totalComprobante) }}</span>
        </template>

        <template v-slot:item.actions="{ item }">
            <v-menu offset-y transition="scale-transition" bottom left>
               <template v-slot:activator="{ on, attrs }">
                 <v-btn color="blue-grey darken-2" dark x-small v-bind="attrs" v-on="on" class="audit-action-btn">
                   Acciones <v-icon right x-small>mdi-chevron-down</v-icon>
                 </v-btn>
               </template>
               <v-list dense class="pa-0">
                 <v-list-item @click="viewXMLRecibido(item)">
                   <v-list-item-icon class="mr-2"><v-icon small color="primary">mdi-file-download</v-icon></v-list-item-icon>
                   <v-list-item-title>XML Recibido</v-list-item-title>
                 </v-list-item>
                 <v-list-item @click="viewXMLFirmado(item)">
                   <v-list-item-icon class="mr-2"><v-icon small color="blue-grey">mdi-file-export</v-icon></v-list-item-icon>
                   <v-list-item-title>Mensaje Receptor</v-list-item-title>
                 </v-list-item>
                 <v-list-item @click="viewXMLRespuesta(item)">
                   <v-list-item-icon class="mr-2"><v-icon small color="teal">mdi-check-decagram</v-icon></v-list-item-icon>
                   <v-list-item-title>XML Respuesta</v-list-item-title>
                 </v-list-item>
               </v-list>
            </v-menu>
        </template>
      </v-data-table>
    </div>

    <!-- PANEL DE RESUMEN FINANCIERO (FOOTER) 💰 -->
    <v-footer v-if="items2.length > 0" padless class="audit-footer elevation-4 flex-column">
      <!-- FILA 1: DESGLOSE TÉCNICO (RESTAURADO) 📉 -->
      <div class="footer-technical-row d-flex align-center pa-2 px-4 w-full border-bottom overflow-x-auto">
         <div class="tech-item mr-4">
            <span class="tech-label caption font-weight-bold" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">EXENTO:</span>
            <span class="tech-value font-weight-bold ml-1 caption" :class="$vuetify.theme.dark ? 'white--text' : ''">₡{{ financialTotals.exento }}</span>
         </div>
         <v-divider vertical class="mx-2" />
         <div class="tech-item mr-4">
            <span class="tech-label caption font-weight-bold" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">IVA 1%:</span>
            <span class="tech-value font-weight-bold ml-1 caption" :class="$vuetify.theme.dark ? 'white--text' : ''">₡{{ financialTotals.iva1 }}</span>
         </div>
         <div class="tech-item mr-4">
            <span class="tech-label caption font-weight-bold" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">IVA 2%:</span>
            <span class="tech-value font-weight-bold ml-1 caption" :class="$vuetify.theme.dark ? 'white--text' : ''">₡{{ financialTotals.iva2 }}</span>
         </div>
         <div class="tech-item mr-4">
            <span class="tech-label caption font-weight-bold" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">IVA 4%:</span>
            <span class="tech-value font-weight-bold ml-1 caption" :class="$vuetify.theme.dark ? 'white--text' : ''">₡{{ financialTotals.iva4 }}</span>
         </div>
         <div class="tech-item mr-4">
            <span class="tech-label caption font-weight-bold" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">IVA 8%:</span>
            <span class="tech-value font-weight-bold ml-1 caption" :class="$vuetify.theme.dark ? 'white--text' : ''">₡{{ financialTotals.iva8 }}</span>
         </div>
         <div class="tech-item mr-4">
            <span class="tech-label caption font-weight-bold" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">IVA 13%:</span>
            <span class="tech-value font-weight-bold ml-1 caption" :class="$vuetify.theme.dark ? 'white--text' : ''">₡{{ financialTotals.iva13 }}</span>
         </div>
         <v-divider vertical class="mx-2" />
         <div class="tech-item">
            <span class="tech-label caption font-weight-bold" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">OTROS CARGOS:</span>
            <span class="tech-value font-weight-bold ml-1 caption" :class="$vuetify.theme.dark ? 'white--text' : ''">₡{{ financialTotals.otrosCargos }}</span>
         </div>
      </div>

      <!-- FILA 2: RESUMEN GENERAL 💰 -->
      <div class="footer-summary-row d-flex align-center pa-3 w-full">
        <div class="summary-item mr-8">
           <span class="summary-label">TOTAL COMPRA NETA</span>
           <v-chip color="grey darken-3" dark label class="ml-2 font-weight-black">₡ {{ financialTotals.subtotalRaw }}</v-chip>
        </div>
        <div class="summary-item mr-8 border-left pl-8">
           <span class="summary-label">TOTAL IVA</span>
           <v-chip color="blue-grey darken-2" dark label class="ml-2 font-weight-black">₡ {{ financialTotals.totalIvaRaw }}</v-chip>
        </div>
        <div class="summary-item">
           <span class="summary-label">TOTAL COMPRAS BRUTAS</span>
           <v-chip color="blue-grey darken-4" dark label class="ml-2 font-weight-black">₡ {{ financialTotals.totalRaw }}</v-chip>
        </div>
      </div>
      <div class="footer-util-row d-flex align-center pa-1 px-4 w-full border-top">
         <div class="total-registros caption font-weight-bold uppercase" :class="$vuetify.theme.dark ? 'blue-grey--text text--lighten-1' : 'grey--text'">
           REGISTROS DE COMPRA EN ESTA CONSULTA: <span :class="$vuetify.theme.dark ? 'teal--text text--lighten-2' : 'blue-grey--text text--darken-3'">{{ items2.length }}</span>
         </div>
         <v-spacer />
      </div>
    </v-footer>

    <!-- VISOR DE DOCUMENTOS (XMLs) REPLICADO DE FACTURACIÓN 📄 -->
    <v-dialog v-model="docViewerDialog" max-width="1100" eager>
      <v-card style="height: 88vh;" class="d-flex flex-column overflow-hidden rounded-xl">
        <div class="doc-viewer-toolbar d-flex align-center px-3 py-2 white--text flex-shrink-0">
          <v-icon color="white" size="18" class="mr-2">mdi-file-document-outline</v-icon>
          <span class="font-weight-bold text-subtitle-2">{{ docViewerTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn icon x-small dark class="mr-1" @click="abrirEnNuevaPestana" title="Abrir en nueva pestaña">
            <v-icon small>mdi-open-in-new</v-icon>
          </v-btn>
          <v-btn icon x-small dark @click="docViewerDialog = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>
        <iframe v-if="docViewerDialog" :src="docViewerUrl" class="flex-grow-1" style="border: none; width: 100%;"></iframe>
      </v-card>
    </v-dialog>

    <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Snackbar from "./shared/Snackbar.vue";

export default {
  components: {
    Snackbar,
  },
  data() {
    return {
      valid: false,
      loading: false,
      criterioReporte: 'Este Mes',
      dateModal: false,
      validEnviarCorreo: false,
      dates: [],
      items2: [],
      selectedMonedas: [],
      monedas: [],
      selectedTiposDocumentos: [],
      tiposDocumentos: [],
      selectedEstadosHacienda: [],
      selectedEstadosAceptacion: [],
      opcionesSistemaCia: [],
      snackText: "",
      snackValue: false,
      docViewerDialog: false,
      docViewerUrl: '',
      docViewerTitle: '',
      dateRules: [
        (v) => (v && v.length == 2) || "Fecha Requerida",
      ],
      headers2: [
        { text: "EMISOR / PROVEEDOR", align: "start", value: "clienteNombre", width: 350 },
        { text: "FECHA", align: "start", value: "fechaString", width: 110 },
        { text: "MONEDA", align: "center", value: "moneda", width: 90 },
        { text: "HACIENDA", align: "center", value: "estadoHaciendaEmisor", width: 150 },
        { text: "ACEPTACIÓN", align: "center", value: "estadoAceptacion", width: 150 },
        { text: "CLASIFICACIÓN", align: "center", value: "clasificacion", width: 160 },
        { text: "SUBTOTAL", align: "end", value: "totalVentaStr", width: 140 },
        { text: "IVA", align: "end", value: "totalImpuestoStr", width: 120 },
        { text: "TOTAL COMPRA", align: "end", value: "totalComprobanteStr", width: 160 },
        { text: "ACCIONES", value: "actions", sortable: false, align: 'right', width: 110 },
      ],
      columns: [
        { label: "Clave Hacienda", field: "clavehacienda" },
        { label: "Nombre Emisor (Proveedor)", field: "clienteNombre" },
        { label: "Cédula Emisor", field: "cedulaReceptor" },
        { label: "Fecha Emisión", field: "fechaString" },
        { label: "Moneda", field: "moneda" },
        { label: "Tipo de Cambio", field: "tipoCambio" },
        { label: "Consecutivo Emisor", field: "consecutivoEmisor" },
        { label: "Estado Hacienda", field: "estadoHaciendaEmisor" },
        { label: "Estado Aceptación", field: "estadoAceptacion" },
        { label: "Consecutivo Receptor (Nuestra Aceptación)", field: "consHacReal" },
        { label: "Tipo de Documento", field: "tipoDocumento" },
        { label: "Sub Total", field: "totalVenta" },
        { label: "Total Descuentos", field: "totalDescuentos" },
        { label: "Total Impuesto (IVA)", field: "totalImpuesto" },
        { label: "Total IVA 1%", field: "totalIva1" },
        { label: "Total IVA 2%", field: "totalIva2" },
        { label: "Total IVA 4%", field: "totalIva4" },
        { label: "Total IVA 8%", field: "totalIva8" },
        { label: "Total IVA 13%", field: "totalIva13" },
        { label: "Total Exento", field: "totalExento" },
        { label: "Total Otros Cargos", field: "totalOtrosCargos" },
        { label: "Total Comprobante", field: "totalComprobante" },
      ],
      estadosHacienda: ["ACEPTADO", "RECHAZADO"],
      estadosAceptacion: ["ACEPTADO", "ACEPTADO PARCIAL", "RECHAZADO", "PENDIENTE"],
      reporteRecibidos: {
        cia: "", fechaInicio: null, fechaFin: null, docNombre: "Compras", 
        cedulaEmisor: "", nombreEmisor: "", clave: "", moneda: "", 
        tipoDocumento: "", estadoAceptacion: "", estadoHaciendaEmisor: "",
      },
    };
  },

  computed: {
    ...mapGetters(["user", "strCia"]),
    filteredItems() {
      // Para la tabla en pantalla, solo mostramos documentos reales
      return this.items2.filter(i => i.clavehacienda && i.clavehacienda.trim() !== '');
    },
    financialTotals() {
      // Usamos filteredItems para las sumas financieras y evitar contar las filas de totales que vienen del servidor
      const subtotal = this.filteredItems.reduce((acc, item) => acc + (item.totalVenta || 0), 0);
      const totalIva = this.filteredItems.reduce((acc, item) => acc + (item.totalImpuesto || 0), 0);
      const total = subtotal + totalIva;
      
      // DESGLOSE TÉCNICO (Restaurado)
      const iva1 = this.filteredItems.reduce((acc, item) => acc + (item.totalIva1 || 0), 0);
      const iva2 = this.filteredItems.reduce((acc, item) => acc + (item.totalIva2 || 0), 0);
      const iva4 = this.filteredItems.reduce((acc, item) => acc + (item.totalIva4 || 0), 0);
      const iva8 = this.filteredItems.reduce((acc, item) => acc + (item.totalIva8 || 0), 0);
      const iva13 = this.filteredItems.reduce((acc, item) => acc + (item.totalIva13 || 0), 0);
      const exento = this.filteredItems.reduce((acc, item) => acc + (item.totalExento || 0), 0);
      const otrosCargos = this.filteredItems.reduce((acc, item) => acc + (item.totalOtrosCargos || 0), 0);

      return {
        subtotalRaw: this.formatPrice(subtotal),
        totalIvaRaw: this.formatPrice(totalIva),
        totalRaw: this.formatPrice(total),
        // Detalle
        iva1: this.formatPrice(iva1),
        iva2: this.formatPrice(iva2),
        iva4: this.formatPrice(iva4),
        iva8: this.formatPrice(iva8),
        iva13: this.formatPrice(iva13),
        exento: this.formatPrice(exento),
        otrosCargos: this.formatPrice(otrosCargos)
      };
    }
  },

  watch: {
    criterioReporte(val) { this.setDatesByCriterion(val); }
  },

  created() {
    this.setDatesByCriterion('Este Mes');
    this.getMonedas();
    this.getTiposDocumentos();
    this.getOpcionesSistemaCia();
  },

  methods: {
    formatPrice(value) {
      if (value === undefined || value === null) return "0.00";
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    setDatesByCriterion(criterion) {
      const today = new Date().toISOString().substr(0, 10);
      const yesterdayDate = new Date(); yesterdayDate.setDate(yesterdayDate.getDate() - 1);
      const yesterday = yesterdayDate.toISOString().substr(0, 10);
      if (criterion === 'Hoy') this.dates = [today, today];
      else if (criterion === 'Ayer') this.dates = [yesterday, yesterday];
      else if (criterion === 'Este Mes') {
        const firstDay = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10);
        this.dates = [firstDay, today];
      }
    },

    clear() {
      this.dates = []; this.selectedMonedas = []; this.selectedTiposDocumentos = []; 
      this.selectedEstadosHacienda = []; this.selectedEstadosAceptacion = [];
      this.reporteRecibidos = { cia: "", fechaInicio: null, fechaFin: null, docNombre: "Compras", cedulaEmisor: "", nombreEmisor: "", clave: "", moneda: "", tipoDocumento: "", estadoAceptacion: "", estadoHaciendaEmisor: "" };
    },

    getReport() { this.getRecibidos(); },
    getOpcionesSistemaCia() { axios.get("api/General/getOpcionesSistemaCia?cia=" + this.strCia).then(r => this.opcionesSistemaCia = r.data); },

    openDocViewer(url, title) {
      this.docViewerUrl = url;
      this.docViewerTitle = title;
      this.docViewerDialog = true;
    },
    abrirEnNuevaPestana() { window.open(this.docViewerUrl, '_blank'); },

    viewXMLRecibido(item) {
      const base = axios.defaults.baseURL || "";
      this.openDocViewer(`${base}/api/Facturacion/getFileContent?cia=${item.cia}&clave=${item.clavehacienda}&type=recibido`, "XML Recibido del Proveedor");
    },
    viewXMLFirmado(item) {
      const base = axios.defaults.baseURL || "";
      // Incluimos consecutivo para localizar el MensajeReceptor
      this.openDocViewer(`${base}/api/Facturacion/getFileContent?cia=${item.cia}&clave=${item.clavehacienda}&type=mensaje&consecutivo=${item.consHacReal}`, "Mensaje de Aceptación/Rechazo (Firmado)");
    },
    viewXMLRespuesta(item) {
      const base = axios.defaults.baseURL || "";
      // Incluimos consecutivo para localizar la Respuesta de Hacienda en compras
      this.openDocViewer(`${base}/api/Facturacion/getFileContent?cia=${item.cia}&clave=${item.clavehacienda}&type=response&consecutivo=${item.consHacReal}`, "Respuesta de Hacienda");
    },

    getMonedas() { axios.get("api/General/getMonedas").then(r => this.monedas = r.data); },
    getTiposDocumentos() { axios.get("api/General/getTipoDocumentos").then(r => this.tiposDocumentos = r.data); },

    sendEmailReport() {
      this.preparePayload();
      axios.post("/api/Reportes/enviarCorreoRecibidos", this.reporteRecibidos).then(r => { this.snackText = r.data; this.snackValue = true; });
    },

    preparePayload() {
      this.reporteRecibidos.cia = this.strCia;
      this.reporteRecibidos.fechaInicio = this.dates[0] ? this.dates[0].toString() : '';
      this.reporteRecibidos.fechaFin = this.dates[1] ? this.dates[1].toString() : (this.dates[0] ? this.dates[0].toString() : '');
      this.reporteRecibidos.docNombre = "Compras";
      this.reporteRecibidos.moneda = this.selectedMonedas.map(m => typeof m === 'object' ? m.md_codigo : m).join(",");
      this.reporteRecibidos.tipoDocumento = this.selectedTiposDocumentos.map(d => typeof d === 'object' ? d.tipoDocumento : d).join(",");
      this.reporteRecibidos.estadoHaciendaEmisor = this.selectedEstadosHacienda.join(",");
      this.reporteRecibidos.estadoAceptacion = this.selectedEstadosAceptacion.join(",");
    },

    getRecibidos() {
      this.loading = true; this.items2 = []; this.preparePayload();
      axios.post("/api/Reportes/getComprasReporte", this.reporteRecibidos)
        .then(r => {
          // Guardamos TODO para el Excel (incluyendo las líneas de totales del servidor)
          this.items2 = r.data;
          
          if (this.opcionesSistemaCia) {
             const opc = this.opcionesSistemaCia.find(o => o.opcionId === "correo_contador");
             if (opc && opc.valor === "true") this.validEnviarCorreo = true;
          }
        })
        .finally(() => this.loading = false);
    },

    // LÓGICA DE CLASIFICACIÓN PRO 🧠📦⚡
    getInvColor(item) {
      const status = item.clasificacion;
      if (status === 'M') return 'indigo darken-2'; // MERCADERÍA
      if (status === 'S') return 'deep-orange darken-3'; // SERVICIOS / GASTOS
      
      return 'grey darken-1';
    },

    getInvText(item) {
      const status = item.clasificacion;
      if (status === 'M') return 'MERCADERÍA';
      if (status === 'S') return 'GASTO / SERV';
      
      return 'PENDIENTE';
    },

    toggleEstadoInventario(item) {
      // Rotación binaria definitiva: M (Mercadería) <-> S (Servicio)
      let nextState = item.clasificacion === 'M' ? 'S' : 'M';

      axios.get(`api/Compras/updateClasificacion?clave=${item.clavehacienda}&cia=${this.strCia}&docNombre=Compras&estado=${nextState}`)
        .then(() => {
          item.clasificacion = nextState;
          this.snackText = "Clasificación actualizada correctamente";
          this.snackValue = true;
        })
        .catch(() => {
          this.snackText = "Error al conectar con la API";
          this.snackValue = true;
        });
    },

    closed() { this.customerModal = false; },
  }
};
</script>

<style scoped>
.report-recibidos-container { background: #f5f5f5; min-height: 100vh; }

/* CABECERA AUDIT */
.audit-header { border-bottom: 2px solid #ddd; background: #fff; }
.audit-title { font-size: 1.25rem; font-weight: 900; margin: 0; letter-spacing: 0.5px; }

/* FILTROS */
.filter-dense-panel { border-bottom: 1px solid #eee; background: #fff !important; }
.audit-input >>> .v-input__control > .v-input__slot { border-radius: 0 !important; font-size: 0.75rem; }
.audit-input >>> fieldset { border-radius: 0 !important; border-color: #eee !important; }
.audit-btn { border-radius: 0 !important; font-weight: 700; letter-spacing: 0.5px; }

/* TABLA */
.audit-table >>> th { background-color: #37474f !important; color: #fff !important; font-size: 0.7rem !important; height: 44px !important; }
.audit-zebra >>> tbody tr:nth-child(even) { background-color: #fcfcfc; }
.audit-action-btn { border-radius: 0 !important; font-size: 0.65rem !important; font-weight: 800 !important; }

/* FOOTER */
.audit-footer { background: #fff; border-top: 3px solid #37474f; }
.summary-label { font-size: 0.75rem; font-weight: 800; color: #666; }
.border-left { border-left: 1px solid #ddd; }
.total-registros { font-size: 0.7rem; }
.doc-viewer-toolbar { background: linear-gradient(135deg, #37474f 0%, #455a64 100%); min-height: 44px; }
.w-full { width: 100%; }
* { border-radius: 0 !important; }

/* ══════════════ MODO OSCURO ══════════════ */
.dark-mode { background: #121212 !important; color: #e0e0e0; }

/* Cabecera / Toolbar */
.dark-mode >>> .audit-header { background: #1a1a1a !important; border-bottom-color: #333 !important; }
.dark-mode >>> .v-toolbar__content .v-icon { color: #78909c !important; }

/* Panel de filtros */
.dark-mode >>> .filter-dense-panel { background: #1e1e1e !important; border-bottom-color: #333 !important; border-color: #333 !important; }
.dark-mode >>> .audit-input .v-input__slot { background: #2a2a2a !important; }
.dark-mode >>> .audit-input fieldset { border-color: #455a64 !important; }
.dark-mode >>> .audit-input .v-label { color: #78909c !important; }
.dark-mode >>> .audit-input input,
.dark-mode >>> .audit-input .v-select__selection { color: #e0e0e0 !important; }
.dark-mode >>> .audit-input .v-input__icon .v-icon { color: #78909c !important; }
.dark-mode >>> .v-divider { border-color: #333 !important; }

/* Tabla */
.dark-mode >>> .v-data-table { background: #121212 !important; }
.dark-mode >>> .v-data-table tbody tr { background: #1a1a1a !important; color: #cfd8dc; }
.dark-mode >>> .v-data-table tbody tr:nth-child(even) { background: #1f1f1f !important; }
.dark-mode >>> .v-data-table tbody tr:hover { background: #263238 !important; }
.dark-mode >>> .v-data-table td { border-bottom: 1px solid #272727 !important; color: #cfd8dc !important; }
.dark-mode >>> .v-data-footer { background: #1a1a1a !important; border-top-color: #333 !important; color: #78909c !important; }
/* Corregir colores Vuetify hardcoded en slots */
.dark-mode >>> .grey--text.text--darken-3,
.dark-mode >>> .grey--text.text--darken-4 { color: #90a4ae !important; }
.dark-mode >>> .caption.grey--text { color: #607d8b !important; }

/* Menú de acciones */
.dark-mode >>> .v-menu__content .v-list { background: #1e1e1e !important; }
.dark-mode >>> .v-menu__content .v-list-item:hover { background: rgba(255,255,255,0.06) !important; }
.dark-mode >>> .v-menu__content .v-list-item__title { color: #e0e0e0 !important; }

/* Footer */
.dark-mode >>> .audit-footer { background: #1a1a1a !important; border-top-color: #455a64 !important; }
.dark-mode >>> .footer-technical-row { background: rgba(255,255,255,0.03) !important; border-bottom-color: #2e2e2e !important; }
.dark-mode >>> .footer-util-row { border-top-color: #2e2e2e !important; }
.dark-mode >>> .border-left { border-left-color: #37474f !important; }
.dark-mode >>> .summary-label { color: #78909c !important; }
.dark-mode >>> .tech-value { color: #cfd8dc !important; }
.dark-mode >>> .total-registros { color: #607d8b !important; }
</style>